import _ from 'lodash';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';

export class RateTable extends TrackableEntity {
    id: number = 0;
    effectETD: string | null = null;
    expireETD: string | null = null;
    mode: string = '';
    origin: string = '';
    destination: string = '';
    doorBy: string = '';
    carrier: string = '';
    remark: string = '';
    size: string = '';
    commodity: string = '';
    rate1: number = 0;
    rate2: number = 0;
    transit: number = 0;
    tbName: string = '';
    tbId: number = 0;
    tbType: number = 0;

    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;

    // for only font-end
    edit: boolean = false;
    view: boolean = false;
    sName: string = '';

    constructor(init?:Partial<RateTable>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('sName','edit', 'view');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(RateTable.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = RateTable.dicFieldMappings[m];
        });

        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_AOTHERINFO' }),
        'effectETD': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO' }),
        'expireETD': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO' }),
        'mode': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO' }),
        'origin': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO' }),
        'destination': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO' }),
        'doorBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO' }),
        'carrier': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO' }),
        'remark': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO' }),
        'size': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO' }),
        'commodity': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO' }),
        'rate1': new DBMappingInfo({ field: 'F_F1', table: 'T_AOTHERINFO' }),
        'rate2': new DBMappingInfo({ field: 'F_F2', table: 'T_AOTHERINFO' }),
        'transit': new DBMappingInfo({ field: 'F_F3', table: 'T_AOTHERINFO' }),
        'tbName': new DBMappingInfo({ field: 'F_TBNAME', table: 'T_AOTHERINFO' }),
        'tbId': new DBMappingInfo({ field: 'F_TBID', table: 'T_AOTHERINFO' }),
        'tbType': new DBMappingInfo({ field: 'F_TYPE', table: 'T_AOTHERINFO' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_AOTHERINFO' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1DATE', table: 'T_AOTHERINFO' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_AOTHERINFO' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2DATE', table: 'T_AOTHERINFO' }),
    };
}
